import React, { createContext, useState, ReactNode } from 'react';

interface DropdownContextType {
	openDropdownId: string | null;
	toggleDropdown: (id: string | null) => void;
}

export const DropdownContext = createContext<DropdownContextType>({
	openDropdownId: null,
	toggleDropdown: () => {},
});

interface DropdownProviderProps {
	children: ReactNode;
}

export const DropdownProvider: React.FC<DropdownProviderProps> = ({ children }) => {
	const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

	const toggleDropdown = (id: string | null) => {
		setOpenDropdownId((prevId) => (prevId === id ? null : id));
	};

	return (
		<DropdownContext.Provider value={{ openDropdownId, toggleDropdown }}>
			{children}
		</DropdownContext.Provider>
	);
};
